import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router } from "react-router-dom";
import "components/fontawesome";

// import "./admin-lte/adminlte.css";
import App from "./App";
import GlobalContext from "./GlobalContext";
// import { getTicket } from "./qlik-api/engine";
import { getUrlParameter, isTouchDevice } from "utils/utils";
import loadQlikTranslations from "utils/qlikTranslationLoad";
//import applyURLSelections from "utils/selectionsSupport";
import "utils/classListPolyfill";

// Redirect users from the non-archive app to the archive app,
// using only REACT_APP_QLIK_SERVER (host) and PUBLIC_URL (archive base path).
(function () {
  var loc = window.location;

  // Host to use (e.g., "bi.qnalytics.com" in TEST, "bi.dream.gov.ua" in PROD)
  var host = (process.env.REACT_APP_QLIK_SERVER || "").trim();
  if (!host) return; // nothing to do if host isn't set

  // Normalize PUBLIC_URL to a path with a single leading & trailing slash
  // TEST: "/dream/archive//" -> "/dream/archive/"
  // PROD: "/archive//"       -> "/archive/"
  var rawBase = (process.env.PUBLIC_URL || "/archive/");
  var base = ("/" + rawBase).replace(/\/+/g, "/");
  if (!base.endsWith("/")) base += "/";

  // Only act when we're on the configured host
  if (loc.hostname !== host) return;

  // If we're already on the archive base (PUBLIC_URL), do nothing
  if (loc.pathname.startsWith(base)) return;

  // Build the final URL on the same host, moving to the archive base,
  // preserving query (?...) and hash (#/finPrograms, etc.)
  var targetOrigin = loc.protocol + "//" + host;
  var newUrl = targetOrigin + base + (loc.search || "") + (loc.hash || "");

  loc.replace(newUrl);
})();



if (!HTMLCollection.prototype.forEach) HTMLCollection.prototype.forEach = Array.prototype.forEach;

const main = async () => {
  const isSecure = process.env.REACT_APP_QLIK_SERVER_SCHEME === "https"; //isDev ? true : window.location.protocol === "https:";
  const host = process.env.REACT_APP_QLIK_SERVER;
  const port = process.env.REACT_APP_QLIK_SERVER_PORT || 443; //isDev ? 443 : window.location.port;

  const prefix = "/" + process.env.REACT_APP_QLIK_PROXY;

  const config = {
    host,
    prefix,
    port,
    isSecure,
    baseUrl:
      (isSecure ? "https://" : "http://") +
      host +
      (port ? ":" + port : "") +
      prefix +
      "resources",
  };

  const qlikTicket = getUrlParameter("qlikTicket");

  // add require.js to the document
  const requireTag = document.createElement('script');
  requireTag.type = 'text/javascript';
  requireTag.src=`${config.baseUrl}/assets/external/requirejs/require.js` + (qlikTicket ? `?qlikTicket=${qlikTicket}` : '');
  requireTag.id = 'qliksense-require-tag';
  document.head.appendChild(requireTag);
  requireTag.loaded = new Promise((resolve) => {
      requireTag.onload = () => {
          resolve();
      };
  });

  await requireTag.loaded;

  // add qlik style to the document
  const styleTag = document.createElement('link');
  styleTag.type = 'text/css';
  styleTag.rel = 'stylesheet';
  styleTag.href = `${config.baseUrl}/autogenerated/qlik-styles.css`
  styleTag.id = 'qliksense-styles-tag';
  document.head.appendChild(styleTag);
  styleTag.loaded = new Promise((resolve) => {
      styleTag.onload = () => {
          resolve();
      };
  });

  await styleTag.loaded;

  window.require.config(config);

  // console.log(window.require);

  window.require(['js/qlik'], function (qlik) {
    qlik.on("error", function (error) {
      console.error("Qlik error", error);
    });

    const onTouchDevice = isTouchDevice();

/*     const lang = getUrlParameter("lang");
    const qlikLang = lang === "ua" ? "ru" : lang;
    const langToSet = qlikLang || window.navigator.language; */

    const lang = getUrlParameter("lang");

    // Define possible aliases
    const ukrLangs = ["ua", "uk", "uk-UA"];
    const rusLangs = ["ru", "ru-RU", "rus"];

    // Normalize input
    const normalizedLang = lang ? lang.toLowerCase() : null;

    // Match to Qlik-supported language
    let qlikLang;
    if (ukrLangs.includes(normalizedLang)) {
      qlikLang = "ru"; // Qlik typically uses "ru" for Cyrillic (both UA and RU)
    } else if (rusLangs.includes(normalizedLang)) {
      qlikLang = "ru";
    } else {
      qlikLang = normalizedLang; // fallback to original or browser default
    }

    const langToSet = qlikLang || window.navigator.language;


    //set the language
    // qlik.setLanguage(langToSet);

    qlik.theme.apply('dream-theme');

    window.require(['url-util'], function(urlUtils){
      (async function init() {

        const app = qlik.openApp(process.env.REACT_APP_QLIK_APP, config);

        // await app.bookmark.apply('cb8afe98-cc35-424d-9bba-16e8aa25af70');
        app.bookmark.apply('cb8afe98-cc35-424d-9bba-16e8aa25af70');

        function setLanguage(lang) {
          var l = lang ? lang.toUpperCase() : "UK";
          app.field("_Language").selectValues([l], false, false);
        }

        const langCode = langToSet.split("-")[0]; // "uk-UA" → "uk"
        window._languageSelectionPromise = setLanguage(langCode);

        const translations = await loadQlikTranslations(langCode, urlUtils.staticResourcesPath);


        // Window resize handler - for devices like Galaxy Fold, etc
        // and when device is rotated
        (function () {
          window.addEventListener("resize", resizeThrottler, false);
          var resizeTimeout;
          function resizeThrottler() {
            // ignore resize events as long as an actualResizeHandler execution is in the queue
            if (!resizeTimeout) {
              resizeTimeout = setTimeout(function () {
                resizeTimeout = null;
                actualResizeHandler();
                // The actualResizeHandler will execute at a rate of 15fps
              }, 66);
            }
          }

          function actualResizeHandler() {
            // console.log("Window resize handler");
            qlik.resize();
          }
        })();


        // Router is moved here to be able to navigate history inside App component
        ReactDOM.render(
          <React.StrictMode>
            <GlobalContext.Provider value={{ app, qlik, onTouchDevice, translations }}>
              <Router>
                <App />
              </Router>
            </GlobalContext.Provider>
          </React.StrictMode>,
          document.getElementById("root")
        );
      }());
    });
  });
};

main();
